<template lang="html">
  <nav class="big">
    <a
      v-for="link in site.menu"
      :key="link.uid"
      :href="'/' + $i18n.locale + '/' + link.uid"
      class="nul"
      @click.prevent="goTo(link.uid)"
      >{{ link.title }}</a
    >
  </nav>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["site"]),
  methods: {
    goTo(uid) {
      // scroll to section
      this.$scrollTo("#" + uid, 1000);
      // change url
      this.$router.push({ path: "/" + this.$i18n.locale + "/" + uid });
    }
  }
};
</script>

<style lang="scss" scoped>
nav {
  display: flex;
  flex-direction: column;
}
</style>
